import React, { useState, useEffect, useRef } from 'react';
import './index.scss';
import { getParameterByNameVariant, getParameterByName, getURLParameterByName } from '../../utils';
import {
  APPLE_CLIENT_ID,
  DASHBOARD_BASE_URL,
  DESKTOP_GOOGLE_REDIRECT,
  GOOGLE_CLIENT_ID,
  MS_REDIRECT_URI,
  constructMicrosoftSSOUrl,
} from '../../Constants';
import { verifyAppleIdTokenV2, verifyGoogleIdTokenV2, verifyMicrosoftIdToken } from '../../services/auth';
import Logo from '../../assets/sssb.png';
import { DOMAIN } from '../../Constants/base';

export default function SalesStackLogin() {
  const apiCallingRef = useRef(false);
  const [stateLoading, setStateLoading] = useState('');

  useEffect(() => {
    const googleIdToken = getParameterByNameVariant('id_token');
    const appleIdToken = getURLParameterByName('user');
    const microsoftIdToken = getParameterByNameVariant('client_info');
    console.log('microsoftIdToken', microsoftIdToken);
    if (googleIdToken) {
      setStateLoading('processing');
      const googleSsoCallback = async (response) => {
        if (apiCallingRef.current) return;
        apiCallingRef.current = true;
        const payload = {
          authorization: response,
          tokenKey: localStorage.getItem('authTokenFcm'),
        };
        const { code, data } = await verifyGoogleIdTokenV2(payload);
        if (code) {
          apiCallingRef.current = false;
        }
        if (code === 200) {
          localStorage.setItem('ss-auth-sales', JSON.stringify(data.accessToken));
          window.location.href = `salesstack://open=%s?token=${data.accessToken}`;
        }
      };
      googleSsoCallback(googleIdToken);
    }
    if (appleIdToken) {
      setStateLoading('processing');
      const appleSsoCallback = async (response) => {
        if (apiCallingRef.current) return;
        apiCallingRef.current = true;
        const payload = {
          authorization: response,
        };
        const { code, data } = await verifyAppleIdTokenV2(payload);
        if (code) {
          apiCallingRef.current = false;
        }
        if (code === 200) {
          localStorage.setItem('ss-auth-sales', JSON.stringify(data.accessToken));
          window.location.href = `salesstack://open=%s?token=${data.accessToken}`;
        }
      };
      appleSsoCallback(appleIdToken);
    }
    if (microsoftIdToken) {
      setStateLoading('processing');
      const microsoftSsoCallback = async (response) => {
        if (apiCallingRef.current) return;
        apiCallingRef.current = true;

        const { code, data } = await verifyMicrosoftIdToken(response);
        if (code) {
          apiCallingRef.current = false;
        }
        if (code === 200) {
          localStorage.setItem('ss-auth-sales', JSON.stringify(data.accessToken));
          window.location.href = `salesstack://open=%s?token=${data.accessToken}`;
        }
      };
      microsoftSsoCallback(microsoftIdToken);
    }

    const ssoProvider = getParameterByName('ssoType');
    const authTokenFcm = getParameterByName('authTokenFcm');
    if (authTokenFcm) {
      localStorage.setItem('authTokenFcm', authTokenFcm);
    }

    switch (ssoProvider) {
      case 'google': {
        let clientId = encodeURIComponent(GOOGLE_CLIENT_ID);
        let scopes = encodeURIComponent(['openid', 'profile', 'email'].join(' '));
        let redirectUri = encodeURIComponent(DESKTOP_GOOGLE_REDIRECT);
        const url =
          'https://accounts.google.com/o/oauth2/auth' +
          '?client_id=' +
          clientId +
          '&response_type=id_token' +
          '&access_type=offline' +
          '&redirect_uri=' +
          redirectUri +
          '&scope=' +
          scopes;
        console.log(url, 'url');
        window.location.href = url;
        setStateLoading('init');
        break;
      }
      case 'microsoft': {
        const microsoftSSOUrl = constructMicrosoftSSOUrl();
        window.location.href = microsoftSSOUrl;
        setStateLoading('init');
        break;
      }
      case 'apple': {
        const appleAuthUrl = constructAppleAuthUrl(
          APPLE_CLIENT_ID,
          `${DASHBOARD_BASE_URL}/v1/user/v2/login/sso/apple/callback/desktop`,
          'code id_token',
          'name email',
          'nonce',
          'form_post',
          '16b38648-6f1a-4c19-ad6c-bee48c72bbbc',
          '11',
          '1.5.5'
        );
        console.log(appleAuthUrl);
        window.location.href = appleAuthUrl;
        setStateLoading('init');
        break;
      }
      default:
        console.log('default');
    }
  }, []);

  const constructAppleAuthUrl = (clientId, redirectUri, responseType, scope, nonce, responseMode, frameId, m, v) => {
    const baseUrl = 'https://appleid.apple.com/auth/authorize';

    const urlParams = new URLSearchParams({
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: responseType,
      scope: scope,
      nonce: nonce,
      response_mode: responseMode,
      frame_id: frameId,
      m: m,
      v: v,
    });
    return `${baseUrl}?${urlParams.toString()}`;
  };

  return (
    <div>
      {stateLoading === 'processing' ? (
        <div className="sso-loginpage">
          <div className="sso-loginpage-inner">
            <img src={Logo} className="sso-loginpage-inner-image" />
            <div className="sso-loginpage-inner-title">Opening #salesstack...</div>
          </div>
        </div>
      ) : (
        <div className="sso-loginpage"></div>
      )}
    </div>
  );
}
